import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Main.css';
import Homepage from "./Homepage";

const MainPage = () => {
    const navigate = useNavigate();
    const [shouldShowHomepage, setShouldShowHomepage] = useState(false);

    useEffect(() => {
        const isAuthenticated = localStorage.getItem('isAuthenticated');
        const isNewlyRegistered = localStorage.getItem('isNewlyRegistered');

        if (isNewlyRegistered || isAuthenticated) {
            localStorage.removeItem('isNewlyRegistered');
            localStorage.setItem('isAuthenticated', true);
            navigate('/statistics');
        } else {
            setShouldShowHomepage(true); // ✅
        }
    }, [navigate]);

    return shouldShowHomepage ? <Homepage /> : null;
};

export default MainPage;
